//import datos from "../../assets/issue-pack.json";

export function addLibrary(state, lib) {
    var mag = state.library.find((i) => i.id == lib.id);
    if (!mag) {
        state.library.push(lib)
    }
}

export function removeLibrary(state, lib) {
    state.library = state.library.filter((i) => i.id !== lib.id);
}

export function clearLibrary(state) {
    state.library = []
}

export function payTotal(state, lib) {
    state.totalPay = lib;
}

export function validateLibrary(state, exist) {
    state.library = state.library.filter(item => !exist.some(e => e.prodId === item.prodId));

}